import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as FieldComponents from "@Shared/components/sections/index";
import MortgageDetailsMixin from "@Broker/@Modules/clients/applications/application/select-options/mortgage-details-mixin";
import { mapMutations } from "vuex";
import { MIRROR_SUBMISSION_AND_QUALIFYING } from "../../../../store/application-mutations";
import { createHelpers } from "@joandvgv/vuex-map-fields";
import { DEFAULT_AMORTIZATION_YEARS_VALUE } from "@Shared/@Utils/application-defaults-utils/application-default-values-constants";
import { kebabCase, mapValues } from "lodash";
const {
  mapFields
} = createHelpers({
  getterType: "getDetails",
  mutationType: "setDetails"
});
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "QualifyingDetails",
  components: _objectSpread({}, FieldComponents),
  mixins: [MortgageDetailsMixin],
  props: {
    calculatedValues: {
      type: Object,
      default: () => ({})
    },
    editVisibility: {
      type: Boolean,
      default: false
    },
    pathName: {
      type: String,
      default: ""
    },
    mortgageIndex: {
      type: Number,
      default: 0
    }
  },
  computed: _objectSpread(_objectSpread({
    visibilityPaths() {
      return mapValues(this.paths, (path, key) => `${path}[${kebabCase(key)}]`);
    },
    paths() {
      const qualifyingDetails = `${this.pathName}[qualifying-details]`;
      return {
        compoundedPeriod: qualifyingDetails,
        amortizationYears: qualifyingDetails,
        interestOnly: qualifyingDetails,
        interestRate: qualifyingDetails,
        amortizationMonths: qualifyingDetails
      };
    }
  }, mapFields("ApplicationStore", {
    compoundedPeriod() {
      return this.paths.compoundedPeriod;
    },
    amortizationYears() {
      return this.paths.amortizationYears;
    },
    interestOnly() {
      return this.paths.interestOnly;
    },
    interestRate() {
      return this.paths.interestRate;
    },
    amortizationMonths() {
      return this.paths.amortizationMonths;
    }
  })), {}, {
    amortizationYearsAndMonths: {
      get() {
        const yearsToMonths = _parseInt(this.amortizationYears || 0) * 12;
        return _parseInt(this.amortizationMonths || 0) + yearsToMonths;
      },
      set(monthsCount) {
        this.amortizationYears = Math.floor(_parseInt(monthsCount) / 12).toString();
        this.amortizationMonths = (monthsCount % 12).toString();
      }
    }
  }),
  watch: {
    interestOnly(value) {
      this.amortizationYears = value === false ? DEFAULT_AMORTIZATION_YEARS_VALUE : "0";
      this.amortizationMonths = "0";
    }
  },
  methods: _objectSpread(_objectSpread({}, mapMutations("ApplicationStore", [MIRROR_SUBMISSION_AND_QUALIFYING])), {}, {
    handleVisibility(data) {
      this.$emit("toggle-visibility", data);
    }
  })
});